import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CompraService } from '../../../services/compra.service';
import { Compra } from '../../../models/compra';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';

@Component({
  selector: 'app-compra-nota-modal',
  templateUrl: './compra-nota-modal.component.html',
  styleUrls: ['./compra-nota-modal.component.css'],
  providers: [ CompraService ]
})
export class CompraNotaModalComponent implements OnInit {

  @Output() onSelectedRow = new EventEmitter();
	@Input() qs = "";
	@Input() numero_decimales: number = 2;
	public compras: Array<Compra> = [];
	public selectedRow: Number;
	public compra: Compra;
	public pagination: Pagination;
	public loading = false;
	public format_decimal: String;

	constructor(
		public CompraService: CompraService,
		public bsModalRef: BsModalRef,
	) {
		this.compras = [];
		this.compra = new Compra();
		this.pagination = new Pagination();
    }

	ngOnInit() {
		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos
		
		this.getCompras();
	}

	getComprasBySearch(text){
		let qs = "&razon_social="+text+"&nombre_comercial="+text+"&serie="+text+"&punto_emision="+text+"&secuencial="+text;
		this.pagination.current_page = 1;
		this.getCompras(qs);
	}

	getCompras(qs = ""){
		this.loading = true;
		// qs="&embed=proveedor,tipocomprobante,tipoidentificacion,bodega,detalle,producto&status=A";
		this.CompraService.getAllByNotas("?page="+this.pagination.current_page+"&per_page=10&tipo=C" + qs).subscribe(
			res => {
				this.loading = false;
				this.compras = res.data;
				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
				this.loading = false;
				this.compras = [];
			}
		);
	}



	numeroFactura(compra){
        return compra.serie + "-" + compra.punto_emision + "-" + compra.secuencial;
	}
	
	parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
	}

	onSelectRow(compra, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de usuario
		this.compra = compra;
	}

	onDBLClick(usuario,i){
		this.onSelectRow(usuario,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto usuario
		this.onSelectedRow.emit(this.compra);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	next(){
		this.pagination.current_page++;
		this.getCompras();
	}

	prev(){
		this.pagination.current_page--;
		this.getCompras();
	}

	first(){
		this.pagination.current_page = 1;
		this.getCompras();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getCompras();
	}

	get formatDecimal(){
        return this.format_decimal;
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/compra-nota-modal/compra-nota-modal.component.ts